import LocalisationProvider from './Localisation/LocalisationProvider';
import RouterProvider from './Router/RouterProvider';
import FormsProvider from './Forms/FormsProvider';
import AuthProvider from './Auth/AuthProvider';
import ThemeProvider from './Theme/ThemeProvider';
import WebSocketProvider from './WebSocket/WebSocketProvider';

export default [
    LocalisationProvider,
    RouterProvider,
    FormsProvider,
    AuthProvider,
    ThemeProvider,
    WebSocketProvider,
];
